import { z } from 'zod';
import { TerminalFailureKindSchema } from '../external-tool.schemas';

export const TerminalExecutionOutputSchema = z.object({
  command: z.string(),
  exitCode: z.number(),
  output: z.string(),
  outputLength: z.number(),
  isTimeout: z.boolean().optional(),
  failureKind: TerminalFailureKindSchema.optional(),
});

const TerminalShellSchema = z.enum(['bash', 'zsh', 'sh', 'powershell', 'cmd']);

export const RunCommandInputSchema = z.object({
  command: z.string().min(1),
  description: z.string().optional(),
  cwd: z.string().optional(),
  timeoutMs: z.number().int().positive().optional(),
  idleTimeoutMs: z.number().int().positive().optional(),
  killOnTimeout: z.boolean().optional(),
  shell: TerminalShellSchema.optional(),
});

export const RunBackgroundInputSchema = z.object({
  command: z.string().min(1),
  description: z.string().optional(),
  cwd: z.string().optional(),
  shell: TerminalShellSchema.optional(),
});

export const ReadJobOutputInputSchema = z.object({
  jobId: z.string().min(1),
  tailBytes: z.number().int().positive().optional(),
});

export const KillJobInputSchema = z.object({
  jobId: z.string().min(1),
});

export const InteractiveSessionInputSchema = z.object({
  action: z.enum(['open', 'send', 'read', 'interrupt', 'close']),
  command: z.string().optional(),
  description: z.string().optional(),
  ptyId: z.string().optional(),
  input: z.string().optional(),
  waitMs: z.number().int().positive().optional(),
  cwd: z.string().optional(),
  shell: TerminalShellSchema.optional(),
});

export type RunCommandInput = z.infer<typeof RunCommandInputSchema>;
export type RunBackgroundInput = z.infer<typeof RunBackgroundInputSchema>;
export type ReadJobOutputInput = z.infer<typeof ReadJobOutputInputSchema>;
export type KillJobInput = z.infer<typeof KillJobInputSchema>;
export type InteractiveSessionInput = z.infer<
  typeof InteractiveSessionInputSchema
>;

export type TerminalExecutionOutput = z.infer<
  typeof TerminalExecutionOutputSchema
>;

export {
  TerminalExecutePayloadSchema as TerminalExecuteSsePayloadSchema,
  TerminalExecutePayloadSchema as TerminalExecuteSsePayloadFromUnknownSchema,
} from '../chat-sse';

export type { TerminalExecutePayload as TerminalExecuteSsePayload } from '../chat-sse';
